class VariantUpsellProduct extends HTMLElement {
    constructor() {
        super();
        this.variantsInfo = this.querySelector('script');
        this.form = this.querySelector('form');
        this.product_id = this.querySelector('#variant_upsell_product_id');
        this.image = this.querySelector('.variant-upsell-product__image');
        this.initialId = this.getAttribute('data-initial-id');
        this.refuseButton = this.querySelector('.variant-upsell-product__refuse');
    }

    connectedCallback() {
        if (this.form && this.product_id) {
            this.rerenderContent(this.initialId);
            this.form.addEventListener('submit', this.onSubmitForm.bind(this));
        }
    }

    activate(variant_id, sidebarDrawer) {
        const hideModal = (event) => {
            this.closest('modal-dialog')?.hide();
            sidebarDrawer?.open();
            this.refuseButton?.removeEventListener('click', hideModal)
        }
        if(this.rerenderContent(variant_id) == -1) {
            sidebarDrawer?.open();
            return
        }
        this.closest('modal-dialog')?.show(null);

        this.refuseButton?.addEventListener('click', hideModal);
        window.upsellTest = false;
    }

    rerenderContent(variant_id) {
        if (!this.variantsInfo) return -1;

        const currentVariantInfo = Array.from(JSON.parse(this.variantsInfo.innerHTML))
            .find((variant) => {
                if (variant.parent_id == variant_id) {
                    return true;
                }
            })

        if (!currentVariantInfo || currentVariantInfo.product_id == null) return -1;

        this.product_id.setAttribute('value', currentVariantInfo.product_id);
        this.image.setAttribute('src', currentVariantInfo.image_url);
    }

    onSubmitForm(event) {
        event.preventDefault();
        event.target.querySelector('button[type="submit"]')?.setAttribute('disabled', 'true');
        const formData = new FormData(event.target);
        if(window.lastTIBProduct) {
            Object.entries(window.lastTIBProduct.properties).forEach(([key, value]) => {
                formData.append(`properties[${key}]`, value);
            });
            formData.append(`parent_line_key`, window.lastTIBProduct.key);
        }
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
        }).then((data) => {
            return data.json();
        }).then((data) => {
            event.target.querySelector('button[type="submit"]')?.removeAttribute('disabled');
            this.closest('modal-dialog')?.hide();
            document.dispatchEvent(
                new CustomEvent("product:added",
                    {
                        bubbles: !0,
                        detail: {
                            quantity: data.quantity,
                            variant: data.variant_id,
                            final: true
                        }
                    })
            )
        })
    }
}

customElements.define('variant-upsell-product', VariantUpsellProduct);